import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {ModalService} from '../../../services/modalService/modal.service';
import {CloseSessionsComponent} from '../zoomView/close-sessions/close-sessions.component';
import {ModalHelper} from '../../../services/modalService/modal.helper';
import {GoogleAnalyticsService} from "../../../services/google-analytics-service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-closed-session',
  templateUrl: './closed-session.component.html',
  styleUrls: ['./closed-session.component.css', '../myreports.component.css']
})
export class ClosedSessionComponent implements OnInit {
  ruid: string;
  closedSessions;
  totalSessions: number = 0;
  isLicense: string;
  isLoggedIn: boolean = false;
  currentUser: any;
  count: number = 0;

  constructor(private apiService: ApiService,
              private ga: GoogleAnalyticsService,
              private route: ActivatedRoute,
              private loginService: LoginService,
              private modalService: ModalService,
              private notifications: NotificationsService,
              private modalHelper: ModalHelper,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.loginService.isLoggedIn()
      .subscribe((isLoggedIn) => {
          this.currentUser = isLoggedIn;
          this.isLoggedIn = this.currentUser.isLoggedIn;
      });

    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getClosedSessions(this.ruid)
                .subscribe((closedSesionsRes) => {
                  this.totalSessions = closedSesionsRes.sessionsTotalNr;
                  this.count = closedSesionsRes.sessionsNr;
                  this.closedSessions = closedSesionsRes.sessionsByWorkstationAndFeature;
                }, (closedSessionErr) => {
                    this.notifications.error(this.translate.instant('common.error'),
                        this.apiService.getMessageFromError(closedSessionErr, this.translate.instant('reports.closedSessions.closedSessionError') + this.ruid));
                });
            }
          }, (error) => {
            this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.closedSessions.invalidRuid')));
          });
      }
    });
  }

  downloadCSV(xls) {
    this.ga.emitEvent('Reports Actions', 'Download CSV Report', 'Click');
    this.apiService.getCSV(this.ruid, 'CLOSED', xls);
  }

  zoomView() {
    this.modalService.open(CloseSessionsComponent, {
      title: this.translate.instant('reports.closedSessions.closedession'),
      data: {
        totalSessions: this.totalSessions,
        count: this.count,
        closedSessions: this.closedSessions,
        currentUser: this.currentUser
      }
    }).subscribe(model => {
    });
  }

    public loginPrompt() {
        this.modalHelper.openLogin({});
    }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/closed-session/closed-session.component.ts